// Конфигурация приложения
const config = {
  // API URL - берем из переменных окружения или используем значение по умолчанию
  API_URL_PATH: process.env.REACT_APP_API_URL_PATH || 'https://doctors-rating-api.spaceapp.ru/api/v1',
};

export default config; 